import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CommonValues } from 'src/app/services/commonValues';
import { BusinessBannerComponent } from '../business-banner/business-banner.component';
import { businessTabReload$, scrollBusinessToFreezePoint } from '../navigation-header/navigation-header.component';
import { WidgetModule } from '../../../widget/widget.module';
import { BusinessMemberCardComponent } from '../business-member-card/business-member-card.component';
import { BusinessAdminCardsComponent } from '../business-admin-cards/business-admin-cards.component';
import { JobCreationTriggerService } from 'src/app/services/job-creation-trigger.service';

export type Credentials = { password: string, username: string };

@Component({
  selector: 'app-business',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    BusinessBannerComponent,
    BusinessMemberCardComponent,
    BusinessAdminCardsComponent,
    WidgetModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss']
})


export class BusinessComponent implements OnInit, OnDestroy {
  @ViewChild('landingside3') landingside3: ElementRef;
  home: Boolean = true;
  about: Boolean = true;
  COMMONWIGETPAGE : string;
  menu = 'home';
  DeactivateMenu: "pageadmin" | null = null;
  userType = "ALL";
  passdata: any[];
  adminWidgets: any[];
  landingsidesticky1: boolean = false;
  @ViewChild('landingside1') menuElement: ElementRef;
  constructor(
     private commonvalues: CommonValues,
     private router: Router,
     private _activate_route: ActivatedRoute,
     private jobCreationTrigger: JobCreationTriggerService,
     private cdr: ChangeDetectorRef,
  ) {

    this.tabReloadSub = businessTabReload$.subscribe(() => this.reloadTab());

    this.routerEventsSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // This layout persists across its menu pages, so the constructor's
        // scrollTo only ran on first entry. On a path change bring the content
        // back to the top (query-param-only changes keep position).
        this.currentRoute = event.url;
        const path = event.urlAfterRedirects.split('?')[0];
        if (this.lastPath && path !== this.lastPath) {
          scrollBusinessToFreezePoint();
        }
        this.lastPath = path;
      }
    });
    window.scrollTo(0, 0);

    this._activate_route.queryParams.subscribe(res => {
      let data:any={}
      data.viewingAsMember=res.viewingAsMember;
       this.adminWidgets=data;
      if (res.menu === "pageadmin") {
        // this.menu = 'pageadmin';
        localStorage.setItem('isSuperAdmin', 'true');
        this.DeactivateMenu = 'pageadmin';
      }
      if (res.businessNameEdited == "true") {
        this.businessNameEdited = true
        this.notificationTitle = 'Business Name Changed';
        this.notificationContent = 'Business name has been changed, it will take some time to show up in the profile and other parts of the platform.'
      }
      if (res.businessLocationEdited == "true") {
        this.businessLocationEdited = true
        this.notificationTitle = 'Business Location Changed';
        this.notificationContent = 'Business location has been changed, it will take some time to show up in the profile and other parts of the platform.'
      }
    });
  }

  notificationTitle: any;
  notificationContent: any;
  businessNameEdited: boolean = false;
  businessLocationEdited: boolean = false;
  currentRoute: string;
  private lastPath = '';
  private routerEventsSub: Subscription;
  private tabReloadSub: Subscription;

  /** Removing and re-adding the router-outlet destroys the active tab and
   *  mounts it fresh, so its ngOnInit runs and it fetches its data again. */
  outletAlive = true;

  reloadTab(): void {
    this.outletAlive = false;
    this.cdr.detectChanges();
    this.outletAlive = true;
  }

  /** Right sidebar mode.
   *  true  → wireframe: one sidebar on every tab (incl. About), fixed
   *          admin / member widget lists.
   *  false → existing behaviour: each tab shows its own widget set and About
   *          has no sidebar (the old template blocks are kept untouched). */
  useWireframeSidebar = false;

  // ── Side columns sticky offset (left cards + right widgets) ──
  // Fits on screen → stick 80px under the header. Taller than the screen →
  // negative top, so it scrolls with the page until its bottom reaches the
  // screen bottom (14px gap) and sticks there. No inner scrollbar.
  private stickyCols = new Map<string, { el: HTMLElement, observer: ResizeObserver }>();

  /** Left + right columns each scroll on their own (wireframe .left-col /
   *  .sidebar-wrap: sticky, max-height = screen, overflow-y auto, 3px
   *  scrollbar) while posts scroll with the page. false = previous sticky-B
   *  behaviour via updateStickyTop. */
  useWidgetInnerScroll = true;

  @ViewChild('leftCol') set leftCol(ref: ElementRef<HTMLElement>) {
    if (this.useWidgetInnerScroll) { return; }
    this.watchStickyCol('left', ref);
  }

  // Both right-sidebar blocks (per-tab and wireframe) carry #rightCol; only
  // one exists at a time.
  @ViewChild('rightCol') set rightCol(ref: ElementRef<HTMLElement>) {
    if (this.useWidgetInnerScroll) { return; }
    this.watchStickyCol('right', ref);
  }

  private watchStickyCol(key: string, ref: ElementRef<HTMLElement>): void {
    const prev = this.stickyCols.get(key);
    if (prev?.el === ref?.nativeElement) { return; }
    prev?.observer.disconnect();
    this.stickyCols.delete(key);
    const el = ref?.nativeElement;
    if (!el) { return; }
    // Re-measure whenever the column changes height (data loads, view switch).
    const observer = new ResizeObserver(() => this.updateStickyTop(el));
    observer.observe(el);
    this.stickyCols.set(key, { el, observer });
    this.updateStickyTop(el);
  }

  @HostListener('window:resize')
  updateAllStickyTops(): void {
    this.stickyCols.forEach(c => this.updateStickyTop(c.el));
  }

  private updateStickyTop(el: HTMLElement): void {
    const headerOffset = 80;
    const top = Math.min(headerOffset, window.innerHeight - el.offsetHeight - 14);
    el.style.top = top + 'px';
  }

  ngOnInit() {
    this.currentRoute = this.router.url;
    this.COMMONWIGETPAGE = this.getPage();
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnDestroy(): void {
    // Without this the scroll reset above kept firing on navigations after
    // leaving the business page.
    this.routerEventsSub?.unsubscribe();
    this.tabReloadSub?.unsubscribe();
    this.stickyCols.forEach(c => c.observer.disconnect());
    // if (this.clickEventsubscription) {
    //   this.clickEventsubscription.unsubscribe();
    // }
  }

  isActive(route: string): boolean {
    return this.currentRoute === route;
  }

  isChildActive(parentRoute: string): boolean {
    return this.currentRoute.startsWith(parentRoute);
  }

  // Add below code for Load page from top
  // ngAfterViewChecked() {
  //   window.scrollTo(0, 0);
  // }


  addTodo(commondata) {
    // console.log(commondata);
    // this.todos = [{label, id: this.todos.length + 1, complete: true }];
    this.passdata = commondata;
    let data:any={}
    data.viewingAsMember=commondata.viewingAsMember;
    this.adminWidgets=data;
    if (!commondata.isSuperAdmin && !commondata.admin) {
      this.userType = "ALL";
    } else {
      this.userType = "ADMIN";
    }

  }

  updatePage(v :string){

    if(v === 'CLICKED'){
      this.COMMONWIGETPAGE = this.getPage();
    }

  }

  getPage() : string {
    return this.isChildActive('/business/post') ? 'BUSINESS_HOME_PAGE' :
     this.isChildActive('/business/about') ? 'BUSINESS_HOME_PAGE' :
     this.isChildActive('/business/followerRequest-sent') ? 'BUSINESS_FOLLOWR_PAGE' :
     this.isChildActive('/business/follower') ? 'BUSINESS_FOLLOWR_PAGE' :
     this.isChildActive('/business/employee-requests') ? 'BUSINESS_EMPLOYEE_REQ_PAGE' :
     this.isChildActive('/business/employee') ? 'BUSINESS_EMPLOYEE_PAGE' :
     this.isChildActive('/business/community') ? 'BUSINESS_COMMUNITY_PAGE' :
     this.isChildActive('/business/analytics') ? 'BUSINESS_ANALYTIC_PAGE' :
     this.isChildActive('/business/admin') ? 'BUSINESS_ADMIN_PAGE' :
     this.isChildActive('/business/business-settings') ? 'BUSINESS_ADMIN_PAGE' :
     this.isChildActive('/business/deactivate') ? 'BUSINESS_DEACTIVATE_PAGE' :
     this.isChildActive('/business/jobs') ? 'BUSINESS_JOB_PAGE' : 'BUSINESS_JOB_PAGE';
  }

  isAboutUsRoute(): boolean {
    return this.isChildActive('/business/about');
  }

  /** Left company card: visitors, and admins previewing in Member View. */
  showMemberCard(q: any): boolean {
    if (!q) { return false; }
    const isAdmin = q.isSuperAdmin == 'true' || q.isAdmin == 'true';
    return !isAdmin || q.viewingAsMember == 'true';
  }

  openJobsTab(): void {
    this.openTab('jobs');
  }

  openTab(tab: string): void {
    const target = '/business/' + tab;
    // Same-URL navigation is ignored by the router, so scroll up and remount
    // the tab to reload it.
    if (this.router.url.split('?')[0] === target) {
      scrollBusinessToFreezePoint();
      this.reloadTab();
      return;
    }
    this.router.navigate([target], { queryParamsHandling: 'merge' });
  }

  /** Page Health "Services listed" → Add: About → Services with the Edit
   *  Services modal opened (company-services reads `openEdit`). Jump to the
   *  top first: the modal locks body scroll and would freeze the smooth
   *  scroll-to-top that the path change starts. Blur the Add button too:
   *  NgbModal refocuses it on close, scrolling the page back down to it. */
  openServicesEditor(): void {
    (document.activeElement as HTMLElement)?.blur();
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    this.router.navigate(['/business/about/services'], {
      queryParams: { openEdit: 'services' },
      queryParamsHandling: 'merge'
    });
  }

  /** Quick Actions → Post a Job: opens the header's Create Job form. */
  postJob(): void {
    this.jobCreationTrigger.trigger('JOBS');
  }

  /** Same destination as Apps → Admin Center. */
  openAdminCenter(): void {
    this.router.navigate(['/user-management/company/profile']);
  }


}

